<div class="grid-form-control" [class.required]="form?.controls[this.entry.formControlAttributes?.formControlName]?.invalid">
    <div class="grid-form-control-text">
        @if(this.errorString) {
            <span [matTooltip]="this.errorString"><span class="material-symbols-outlined warning-icon">warning</span></span>
        }
        @else {
            <span class='material-symbols-outlined success-green'>check_circle</span>
        }
    </div>
</div>